import React, { useState } from "react";
import "components/client/dashboard/profile/Cards/cards.css";
import "./referral.css";
import "components/rep/settings/subscriptions/cancel/cancel.css";
import { IoGift } from "react-icons/io5";
import { IoClose } from "react-icons/io5";
import RepReferrals from "../settings/RepReferrals";
import { useHistory } from "react-router-dom";
interface ReferralsButtonProps {
  fromDrawer?: boolean;
  hideTrigger?: boolean;
  isOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
}
const ReferralsButton: React.FC<ReferralsButtonProps> = ({
  fromDrawer = false,
  hideTrigger = false,
  isOpen,
  onOpenChange,
}) => {
  const history = useHistory();
  const isControlled = typeof isOpen === "boolean";
  const [internalOpen, setInternalOpen] = useState<boolean>(false);
  const showModal = isControlled ? !!isOpen : internalOpen;
  const setShowModal = (next: boolean | ((prev: boolean) => boolean)) => {
    const resolved =
      typeof next === "function"
        ? (next as (prev: boolean) => boolean)(showModal)
        : next;
    if (isControlled) {
      onOpenChange?.(resolved);
    } else {
      setInternalOpen(resolved);
      onOpenChange?.(resolved);
    }
  };

  const handleRelocate = () => {
    setShowModal(false);
    history.push("/rep/rewards");
  };
  return (
    <>
      {!hideTrigger && (
        <button
          className={fromDrawer ? "drawer-nav-link" : "referral-button"}
          onClick={() => setShowModal((prev) => !prev)}
        >
          {fromDrawer ? (
            <>
              <IoGift style={{ width: 20, height: 20, margin: 0 }} />
              <span>Referrals</span>
            </>
          ) : (
            <IoGift />
          )}
        </button>
      )}
      <div className={`custom-scroll-sm cr-modal ${showModal ? "open" : ""}`}>
        <button className="mrc-close-btn" onClick={() => setShowModal(false)}>
          <IoClose style={{ color: "#000", fontSize: 20 }} />
        </button>
        <RepReferrals />

        <button
          className="cancel-un-follow-btn"
          style={{ borderRadius: 4, marginTop: 8 }}
          onClick={handleRelocate}
        >
          Rewards
        </button>
      </div>
      {showModal && (
        <div className="mrc-overlay" onClick={() => setShowModal(false)} />
      )}
    </>
  );
};

export default ReferralsButton;
